import { render, staticRenderFns } from "./ClientAdminToolbar.vue?vue&type=template&id=33d08d9c&scoped=true&"
import script from "./ClientAdminToolbar.vue?vue&type=script&lang=js&"
export * from "./ClientAdminToolbar.vue?vue&type=script&lang=js&"
import style0 from "./ClientAdminToolbar.vue?vue&type=style&index=0&id=33d08d9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d08d9c",
  null
  
)

export default component.exports